import React from "react";
import Layout from "../layouts/Layout";
import Hero from "../components/product-services/Hero";
import KitsSection from "../components/product-services/KitsSection";
import VRLabsSection from "../components/product-services/VRLabsSection";
import SteamWordsSection from "../components/product-services/SteamWordsSection";

const ProductAndServices = () => {
  return (
    <Layout>
      <Hero />
      <KitsSection />

      <SteamWordsSection />
      <VRLabsSection />
    </Layout>
  );
};

export default ProductAndServices;
